import { Box } from "@mui/material";
import { AddEditCustomInvoiceForm } from "../../components/invoices";
import { PageLayout } from "../../layouts/PageLayout";
import { PageHeader } from "../../components/v3";
import { useParams } from "react-router-dom";

export const AddEditCustomInvoice = () => {
  const { id } = useParams();
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader title={id ? "Edit Invoice" : "Create Invoice"} />
      </Box>
      <Box sx={{ mt: -9, zIndex: 2, position: "relative" }}>
        <AddEditCustomInvoiceForm invoiceId={id} />
      </Box>
    </PageLayout>
  );
};
